import React from "react";
import {
  Breadcrumb,
  Card,
  CardBody,
  CardText,
  CardTitle,
  Container,
} from "react-bootstrap";
import { Link, Outlet, useLocation } from "react-router-dom";

function Tool({ title, description, component: Component }) {

  const location = useLocation();

  let currentLink = ''

  const crumbs = location.pathname.split('/')
    .filter(crumb => crumb !== '')
    .map(crumb => {
      currentLink += `/${crumb}`

      return (
        <Breadcrumb.Item className="link-dark" href={currentLink} as={Link} to={currentLink} key={crumb}>{crumb.toLocaleUpperCase()}</Breadcrumb.Item>
      )
    })

  return (
    <Container className="mt-3 mb-5">
      <Breadcrumb>
        {crumbs}
      </Breadcrumb>
      <Card className="mb-3">
        <CardBody>
          <CardTitle className="fw-bold">{title}</CardTitle>
          <CardText>{description}</CardText>
        </CardBody>
      </Card>
      {/* Render the passed component or fallback to Outlet for nested content */}
      {Component ? <Component /> : <Outlet />}
      {/* <Outlet/> */}
    </Container>
  );
}

export default Tool;
